import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.cdccompass.com/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;